// D-DRUGREF colors: shared category badge so every view/table matches the DrugReference tab.
// Uses the stored per-pharmacy color (server-resolved, override beats global); falls back to the
// default palette; text color derived for contrast.
export const DEFAULT_CAT_COLORS: Record<string, [string, string]> = {
  REMS: ['#E6F1FB', '#0C447C'], Specialty: ['#EEEDFE', '#3C3489'], Procedural: ['#FAEEDA', '#633806'],
  Formulary: ['#E1F5EE', '#085041'], BioInterchange: ['#FBEAF0', '#72243E'], Standard: ['#F1EFE8', '#444441'],
}

export function contrastText(hex: string): string {
  const h = hex.replace('#', '')
  const v = h.length === 3 ? h.split('').map(x => x + x).join('') : h
  const r = parseInt(v.slice(0, 2), 16), g = parseInt(v.slice(2, 4), 16), b = parseInt(v.slice(4, 6), 16)
  return (0.299 * r + 0.587 * g + 0.114 * b) > 150 ? '#1a1a1a' : '#ffffff'
}

export default function CategoryBadge({ name, color }: { name: string | null | undefined; color?: string | null }) {
  if (!name) return <>—</>
  const [bg, fg] = color ? [color, contrastText(color)] : (DEFAULT_CAT_COLORS[name] ?? ['#F1EFE8', '#444441'])
  return <span style={{ fontSize: 11.5, background: bg, color: fg, padding: '2px 9px', borderRadius: 20, whiteSpace: 'nowrap' }}>{name}</span>
}
